var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"no-gutters":""}},[_c('div',[_c('img',{attrs:{"src":_vm.logoCompuesto,"alt":"Facultad de Química UNAM"}})]),_c('v-spacer'),_c('div',{staticClass:"white--text departamento font-weight-bold"},[_vm._v("Programa de Becas Internas")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }